import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import {
  OrderStatus,
  orderStatusNameMap,
} from '../../interfaces/Order/OrderStatus';

interface OrderStatusDropdownProps {
  label?: string;
  value?: OrderStatus;
  onChange: (newStatus?: OrderStatus) => void;
  required?: boolean;
  loading?: boolean;
}

export const OrderStatusDropdown = (props: OrderStatusDropdownProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        flex: '1 1 250px',
        maxWidth: '250px',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          label={props.label}
          value={props.value ?? '__all__'}
          onChange={(e) =>
            props.onChange(
              e.target.value === '__all__'
                ? undefined
                : (e.target.value as OrderStatus),
            )
          }
        >
          {!props.required && <MenuItem value='__all__'>Tümü</MenuItem>}
          {Object.entries(orderStatusNameMap).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {props.loading && <CircularProgress size={24} />}
    </Box>
  );
};
